/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: /product/black-dashboard-react
* Copyright 2019 SecurePoint 360 ()
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by SecurePoint 360

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { SP360IconLogo } from 'assets';
import React from 'react';

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  Row,
  Col,
} from 'reactstrap';

class NotFound extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      openNotificationModal: false,
    };
  }

  render() {
    return (
      <>
        <div className="content">
          <Row>
            <Col md="8">
              <Card>
                <CardHeader>
                  <h5 className="title">Page not found</h5>
                </CardHeader>
                <CardBody></CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Col>
            <Col md="4">
              <Card className="card-user">
                <CardBody>
                  <CardText />
                  <div className="author">
                    <div className="block block-one" />
                    <div className="block block-two" />
                    <div className="block block-three" />
                    <div className="block block-four" />
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img alt="..." className="avatar" src={SP360IconLogo} />
                      <h5 className="title">
                        {this.state.user.first_name} {this.state.user.last_name}
                      </h5>
                    </a>
                    <p className="description">{this.state.user.position}</p>
                  </div>
                  <div className="card-description"></div>
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default NotFound;
